import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import toDollars from 'utils/to-dollars';

import { EntityId } from 'services/entities/types';
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';

// Selectors
import { AppState } from 'services/types';
import TimesheetHolidayGate from 'components/TimesheetHolidayGate';
import { TIMESHEET_HOLIDAYS_MULTIPLIER } from 'services/timesheetHolidays/constants';
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface OwnProps {
    timesheetEntryUuid: string;
}

interface ConnectedProps {
    paidBreakDollars?: number;
    entityId: EntityId;
    date: TimesheetHolidayDate;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetEntryPaidBreakDollarsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { paidBreakDollars, date, entityId } = this.props;
        if (!paidBreakDollars) return null;

        return (
            <TimesheetHolidayGate
                fallback={toDollars(paidBreakDollars)}
                timesheetDate={date}
                timesheetEntityId={entityId}
            >
                {toDollars(paidBreakDollars * TIMESHEET_HOLIDAYS_MULTIPLIER)}
            </TimesheetHolidayGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    paidBreakDollars: makeSelectTimesheetEntryValue('paidBreakDollars'),
    entityId: makeSelectTimesheetEntryValue('entityId'),
    date: makeSelectTimesheetEntryValue('date')
});

export default connect(mapStateToProps)(
    TimesheetEntryPaidBreakDollarsComponent
);
